export default __webpack_public_path__ + "static/media/logo_gcash.e104eee8.png";